import React from 'react';
import { ActElementTable } from '../components/projects/Project/ActElementTable';
import { ActElementPodpisy } from '../components/projects/Project/ActElementPodpisy';
import { ActAttachments } from '../components/projects/Project/ActAttachments';
import { ActElement } from '../components/projects/Project/ActElement';
import forEach from 'lodash.foreach';
import orderBy from 'lodash.orderby';
import moment from 'moment';

export const getActChild = (child, props = {}) => {
	let isOnlyFragment =
		child.childrens && child.childrens.length > 0 ? child.childrens.every((c) => c.name === 'fragment') : false;
	let newChildrens = isOnlyFragment ? joinFragmentElements(child) : null;

	switch (child.name) {
		case 'tabela':
		case 'tabela-word':
			return <ActElementTable {...child} {...props} />;
		case 'podpisy':
			return <ActElementPodpisy {...child} {...props} />;
		case 'zalacznik':
			return <ActAttachments {...child} {...props} />;
		case 'organ-wydajacy':
			return <ActElement element="h3" {...child} {...props} />;
		case 'metryka': {
			const newProps = { ...child };
			const { attributes } = child;
			newProps.text = `${attributes.type} nr ${attributes.number} z dnia ${moment(attributes.date).format(
				'DD MMMM YYYY'
			)} r.`;

			return <ActElement classNameCont="text-center" {...newProps} {...props} />;
		}
		case 'srodtytul':
			return <ActElement classNameCont="text-center text-bold" {...child} {...props} />;
		case 'paragraf': {
			const newProps = { ...child };

			newProps.text = `<div style="text-indent: 20px;"><strong>§ ${child.attributes
				.number}.</strong> ${child.text}</div>`;

			return <ActElement {...newProps} {...props} />;
		}
		case 'punkt': {
			const newProps = { ...child };

			newProps.text = `<div class="list-item list-item--point"><div class="list-item__number">${child.attributes
				.number}.</div><div class="list-item__text">${child.text}${isOnlyFragment
				? newChildrens.text
				: ''}</div></div>`;

			return <ActElement {...newProps} childrens={isOnlyFragment ? [] : newProps.childrens} {...props} />;
		}
		case 'litera': {
			const newProps = { ...child };

			newProps.text = `<div class="list-item list-item--letter"><div class="list-item__number">${child.attributes
				.number})</div><div class="list-item__text">${child.text}</div></div>`;

			return <ActElement {...newProps} {...props} />;
		}
		case 'tiret': {
			const newProps = { ...child };

			newProps.text = `<div class="list-item list-item--tiret"><div class="list-item__number">${child.attributes
				.number}</div><div class="list-item__text">${child.text}</div></div>`;

			return <ActElement {...newProps} {...props} />;
		}
		case 'rozdzial': {
			const newProps = { ...child };

			newProps.text = `<div style="text-align: center; margin-top: 20px;"><strong>Rodział ${child.attributes
				.number}.</strong></div>${child.text}`;

			return <ActElement {...newProps} {...props} />;
		}
		case 'tytul': {
			const newProps = { ...child };

			newProps.text = `<div style="text-align: center;"><strong>${child.text}</strong></div>`;

			return <ActElement {...newProps} {...props} />;
		}
		default:
			return <ActElement {...child} {...props} />;
	}
};

const joinFragmentElements = (child) => {
	let text = '';
	forEach(orderBy(child.childrens, (c) => c.order), (c) => {
		if (c.attributes.isSuperscript) {
			text += `<sup class="act__sup">${c.text}</sup>`;
		} else {
			text += c.text;
		}
	});

	return {
		childrens: [],
		attributes: {},
		canComment: false,
		commentCount: 0,
		comments: [],
		name: 'fragment',
		order: 0,
		id: child.childrens[0].id,
		parentId: child.id,
		text: text,
		type: 0,
		xmlId: null
	};
};
// 4: "zalacznik"
// 15: "podstawa-prawna"
// 16: "uzasadnienie"
